<template>
    <RegisterBonusModal v-if="modalStore.modals[ModalEnum.REGISTER_BONUS]"
                        @close="closeRegisterBonusAndOpenIntroduction" />
    <IntroductionModal v-if="modalStore.modals[ModalEnum.INTRODUCTION]"
                       @close="closeIntroductionAndOpenGuildsSuggestions" />
    <GuildsSuggestionsModal v-if="modalStore.modals[ModalEnum.GUILDS_SUGGESTIONS]"
                            @close="closeGuildsSuggestionsAndOpenDownloadApp" />
    <DownloadAppModal v-if="modalStore.modals[ModalEnum.DOWNLOAD_APP]"
                      @close="closeDownloadAppAndOpenBrowserNotifications" />
    <BrowserNotificationsModal v-if="modalStore.modals[ModalEnum.BROWSER_NOTIFICATIONS]" />
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import RegisterBonusModal from '@/js/quests/dashboard/modals/notifications/RegisterBonusModal.vue';
    import DownloadAppModal from '@/js/quests/dashboard/modals/DownloadAppModal.vue';
    import GuildsSuggestionsModal from '@/js/quests/dashboard/pages/guilds/components/GuildsSuggestionsModal.vue';
    import IntroductionModal from '@/js/quests/dashboard/modals/notifications/IntroductionModal.vue';
    import BrowserNotificationsModal from '@/js/quests/dashboard/modals/BrowserNotificationsModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useOnboardingModalChain } from '@/js/quests/dashboard/composables/useOnboardingModalChain';
    import { useBrowserNotifications } from '@/js/quests/dashboard/composables/useBrowserNotifications';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';

    const modalStore = useModalStore();

    const { isMobileOrTablet } = useDeviceSize();
    const { isSubscribeAvailable } = useBrowserNotifications();

    const isSubscribeModalOpenable = computed(() => !isMobileOrTablet.value && isSubscribeAvailable.value);

    const {
        closeRegisterBonusAndOpenIntroduction,
        closeIntroductionAndOpenGuildsSuggestions,
        closeGuildsSuggestionsAndOpenDownloadApp,
        closeDownloadAppAndOpenBrowserNotifications,
    } = useOnboardingModalChain(isSubscribeModalOpenable.value);
</script>
